import { defineComponent } from 'vue'
import { WIDGET_ICON_MAP } from '~/utils/repository'

export default defineComponent({
  computed: {
    WIDGET_ICON_MAP: () => WIDGET_ICON_MAP
  },
  methods: {
    widgetIcon(key: string) {
      return WIDGET_ICON_MAP[key as keyof typeof WIDGET_ICON_MAP]
    }
  }
})
